import { gql } from '@apollo/client';

const UPDATE_USER = gql`
  mutation updateUser($id: ID!, $user: UserUpdateInput!) {
    updateUser(id: $id, user: $user) {
      success
      message
      user {
        id
      }
    }
  }
`;

const GET_LOCATIONS = gql`
  query locations($params: QueryParams, $name: String) {
    locations(params: $params, name: $name) {
      info {
        count
      }
      results {
        id
        name
      }
    }
  }
`;

export { UPDATE_USER, GET_LOCATIONS }
